import { axiosClient } from "./axiosClient";

// ── Powiadomienia (dzwonek) ──
export type NotificationActor = {
  name: string;
  avatar_url?: string | null;
  profile_ref?: string | null;
};

export type AppNotification = {
  id: string;
  kind: string;
  message: string;
  // Deep-link: target ('group' | 'voting' | …) + target_id; group_id jako kontekst.
  target?: string | null;
  target_id?: string | null;
  group_id?: string | null;
  read: boolean;
  created_at: string;
  updated_at: string;
  actor?: NotificationActor | null;
};

// „Do zrobienia" — akcje do wznowienia jednym tapnięciem (po przypadkowym zamknięciu).
export type PendingVoteConfirmation = { token: string; voting_id?: string | null; voting_title?: string | null; expires_at: string };
export type PendingLoginApproval = { token: string; channel: string; created_at: string; expires_at: string };
export type PendingActions = { vote_confirmations: PendingVoteConfirmation[]; login_approvals: PendingLoginApproval[] };

export type NotificationsMeta = {
  page: number;
  total_pages: number;
  unread_count: number;
  pending_count: number;
  badge_count: number; // nieprzeczytane + akcje do zrobienia
};
export type NotificationsResponse = { notifications: AppNotification[]; pending: PendingActions; meta: NotificationsMeta };
export type UnreadCountResponse = { unread_count: number; pending_count: number; badge_count: number };

export const getNotifications = (page = 1) =>
  axiosClient.get<NotificationsResponse>("notifications", { params: { page } });

export const getUnreadCount = () => axiosClient.get<UnreadCountResponse>("notifications/unread_count");

export const markNotificationRead = (id: string) => axiosClient.post(`notifications/${id}/mark_read`);

export const markAllNotificationsRead = () => axiosClient.post("notifications/mark_all_read");
